import React from 'react';
import ReactGA from 'react-ga';

import PageContent from '../../../components/Layout/PageContent';
import { TableGridApiContextProvider } from '../../../components/TableGrid/TableGridApiContext/TableGridApiContext';
import { CONSTANTS } from '../../../core/config/constants';
import { ColumnPresetContextProvider } from '../shared/ColumnPresetContext/ColumnPresetContext';
import { FilterContextProvider } from '../shared/FinancialDataContext/FinancialDataContext';
import { SearchContextProvider } from '../shared/SearchContext/SearchContext';
import CompaniesPageSearchPanel from './CompaniesPageSearchPanel';
import CompaniesFilter from './Filter/CompaniesFilter';

interface OwnProps {
  path: string;
}

const CompaniesPage: React.FC<OwnProps> = () => {
  ReactGA.pageview(window.location.pathname);

  return (
    <PageContent isPageHeightAuto={false}>
      <TableGridApiContextProvider>
        <SearchContextProvider>
          <FilterContextProvider
            version={CONSTANTS.COMPANIES_FILTER_STORAGE.VERSION}
            storageKey={CONSTANTS.COMPANIES_FILTER_STORAGE.KEY}
          >
            <ColumnPresetContextProvider>
              <CompaniesFilter benchmarkRefinement={false} />
              <CompaniesPageSearchPanel benchmarkRefinement={false} />
            </ColumnPresetContextProvider>
          </FilterContextProvider>
        </SearchContextProvider>
      </TableGridApiContextProvider>
    </PageContent>
  );
};

export default CompaniesPage;
